import React from 'react';
import { NavLink } from 'react-router-dom';
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css"; 

function Navbar() {
    const handleClick = () => {
        window.scrollTo(0, 0);
        const navbarCollapse = document.getElementById('navbarCollapse');
        if (navbarCollapse && navbarCollapse.classList.contains('show')) {
            const toggler = document.querySelector('.navbar-toggler');
            if (toggler) toggler.click();
        }
    };

    return (
        // <nav className="navbar navbar-expand-lg navbar-light bg-white sticky-top px-5 py-3 py-lg-0 shadow-sm">
        <nav className="navbar navbar-expand-lg navbar-light bg-white sticky-top px-5 py-3 py-lg-0 shadow-sm align-items-center">

            <NavLink to="/" className="navbar-brand p-0 d-flex align-items-center" onClick={handleClick}>
                <img 
                    src={`${process.env.PUBLIC_URL}/img/logo.png`} 
                    alt="Logo" 
                    style={{ height: "100px",padding: "10px 0" }} 
                        className="img-fluid navbar-logo"

                />
              <h1
                        className="
                            m-0 ms-2 fw-bold
                            fs-6        /* mobile (default) */
                            fs-sm-6
                            fs-md-5
                            fs-lg-4
                            fs-xl-3
                            text-wrap text-lg-nowrap
                        "
                        style={{ lineHeight: '1.2' }}
                        >
                        Unicell Technologies Limited
                        </h1>

                            </NavLink>

            <button 
                    className="navbar-toggler ms-auto"
                    style={{ marginTop: '-110px' }}
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#navbarCollapse"
                >
                    <span className="fa fa-bars fs-4"></span>
                </button>


            

            <div className="collapse navbar-collapse" id="navbarCollapse">
                <div className="navbar-nav ms-auto py-0">
                    <NavLink to="/" className="nav-item nav-link" onClick={handleClick}>Home</NavLink>
                    <NavLink to="/Aboutus" className="nav-item nav-link" onClick={handleClick}>About Us</NavLink>
                    <NavLink to="/Services" className="nav-item nav-link" onClick={handleClick}>Services</NavLink>
                    <NavLink to="/Gallery" className="nav-item nav-link" onClick={handleClick}>Our Gallery</NavLink>

                    
                    

                    <NavLink to="/Contactus" className="nav-item nav-link" onClick={handleClick}>Contact Us</NavLink>
                </div>
            </div>
        </nav>
    );
}

export default Navbar;